export default "__VITE_ASSET__91e47dcc__"